import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useAppNav } from '@/hooks/useAppNav';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const { showSidebar } = useAppNav();

  // Close sidebar when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen flex-col bg-background text-foreground">
      <Navbar toggleSidebar={toggleSidebar} showSidebar={showSidebar} />

      <div className="flex flex-1 overflow-hidden">
        {showSidebar ? (
          <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        ) : null}

        <main
          className={`flex-1 overflow-y-auto p-4 md:p-6 ${isDesktop && showSidebar ? 'lg:pl-72' : ''}`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 